import { MdLock } from "react-icons/md";
import { Card } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const AssetInfoTrial = () => {
  const size = 20;
  const titlesMobile = [
    "Preço",
    "Seguidores",
    "Moeda",
    "Mudança",
    "Preço Alvo AI",
    "Segurança",
  ];
  const titlesDesktop = ["Preço", "Seguidores", "Preço Alvo AI", "Segurança"];

  if (isMobile) {
    return (
      <Card
        id="trial-step"
        className="pd-30 pd-b-0 mg-t-10"
        style={{ borderRadius: 15, maxWidth: "90%", paddingBottom: 0 }}
      >
        <Swiper
          spaceBetween={20}
          className="swiper-slide"
          slidesPerView={3}
          pagination={{ type: "bullets" }}
        >
          {titlesMobile.map((title, index) => {
            return (
              <SwiperSlide key={index} className="mg-b-60 text-center">
                <h6 className="tx-13 tx-inverse tx-semibold mg-b-0">
                  <MdLock size={size} />
                </h6>
                <span className="d-block tx-11 text-muted">{title}</span>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Card>
    );
  }

  return (
    <Card
      id="trial-step"
      className="pd-20 mg-t-10 mg-b-10"
      style={{ borderRadius: 15, width: "fit-content" }}
    >
      <div className="d-flex" style={{ gap: 20 }}>
        {titlesDesktop.map((title) => {
          return (
            <div className="flex-column" key={title}>
              <h6 className="tx-13 tx-inverse tx-semibold mg-b-0 text-center">
                <MdLock size={size} />
              </h6>
              <span className="d-block tx-11 text-muted">{title}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default AssetInfoTrial;
